import store from '@/store'

function getPermissions() {
  return (store.state.user && store.state.user.permissions) || []
}

export function hasPermission(code) {
  if (!code) return true
  return getPermissions().includes(code)
}

export function hasAnyPermission(codes) {
  if (!codes || !codes.length) return true
  const perms = getPermissions()
  return codes.some(c => perms.includes(c))
}

export function hasAllPermissions(codes) {
  if (!codes || !codes.length) return true
  const perms = getPermissions()
  return codes.every(c => perms.includes(c))
}

export function checkAuth(value, arg) {
  if (value == null || value === '') return true
  if (Array.isArray(value)) {
    return arg === 'all' ? hasAllPermissions(value) : hasAnyPermission(value)
  }
  return hasPermission(value)
}
